<template>
  <div>
    <div :class="$style.logo">
      <div :class="$style.logoContainer">
        <div
          v-if="!settings.isMenuCollapsed || withDrawer"
        >
          <router-link to="/">
            <span style="color:#3bb143;margin-right: 5px;">Farma</span><span style="color:#000;">Jarolím</span>
          </router-link>
        </div>
        <div v-if="settings.isMenuCollapsed && !withDrawer">
          <router-link to="/">
            <span style="color:#3bb143;margin-right: 5px;">F</span><span style="color:#000;">J</span>
          </router-link>
        </div>
      </div>
    </div>
    <div :class="settings.isLightTheme ? [$style.navigation, $style.light] : $style.navigation">
      <vue-custom-scrollbar
        :class="settings.isMobileView ? $style.scrollbarMobile : $style.scrollbarDesktop"
      >
        <a-menu
          :theme="settings.isLightTheme ? 'light' : 'dark'"
          :inlineCollapsed="withDrawer ? false : settings.isMenuCollapsed"
          :mode="'inline'"
          :selectedKeys="selectedKeys"
          :openKeys.sync="openKeys"
          @click="handleClick"
          @openChange="handleOpenChange"
        >
          <template v-for="(item, index) in menuData">
            <item
              v-if="!item.children && !item.divider && !item.hidden"
              :menu-info="item"
              :styles="$style"
              :key="item.key"
            />
            <a-menu-divider v-if="item.divider" :key="index"/>
            <sub-menu v-if="item.children" :menu-info="item" :styles="$style" :key="item.key"/>
          </template>
          <a-menu-divider/>
          <a-menu-item :key="'company'">
            <span>
              <span :class="$style.title">Nastavení firemních údajů</span>
              <ion-icon name="cog-outline" :class="[$style.icon]"></ion-icon>
            </span>
          </a-menu-item>
          <a-menu-item :key="'settings'">
            <span>
              <span :class="$style.title">Nastavení šablony</span>
              <ion-icon name="color-palette-outline" :class="[$style.icon]"></ion-icon>
            </span>
          </a-menu-item>
        </a-menu>
      </vue-custom-scrollbar>
    </div>
  </div>
</template>

<script>
import store from 'store'
import _ from 'lodash'
import vueCustomScrollbar from 'vue-custom-scrollbar'
import { getLeftMenuData } from '@/services/menu'
import SubMenu from './partials/submenu'
import Item from './partials/item'

export default {
  name: 'menu-left',
  components: { vueCustomScrollbar, SubMenu, Item },
  props: {
    settings: Object,
    withDrawer: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.openKeys = store.get('app.menu.openedKeys') || []
    this.selectedKeys = store.get('app.menu.selectedKeys') || []
    this.setSelectedKeys()
  },
  data() {
    return {
      menuData: getLeftMenuData,
      selectedKeys: [],
      openKeys: [],
    }
  },
  watch: {
    'settings.isMenuCollapsed'() {
      this.openKeys = []
    },
    '$route'() {
      this.setSelectedKeys()
    },
  },
  methods: {
    handleClick(e) {
      if (e.key === 'settings') {
        this.$store.commit('CHANGE_SETTING', { setting: 'isSettingsOpen', value: true })
        return
      }
      if (e.key === 'company') {
        this.$store.commit('companyInformation/SET_VISIBILITY', true)
        return
      }
      store.set('app.menu.selectedKeys', [e.key])
      this.selectedKeys = [e.key]
    },
    handleOpenChange(openKeys) {
      store.set('app.menu.openedKeys', openKeys)
      this.openKeys = openKeys
    },
    setSelectedKeys() {
      const pathname = this.$route.path.includes('/ecommerce/product/') && !this.$route.path.includes('add') && !this.$route.path.includes('detail') ? '/ecommerce/product/' : this.$route.path
      const menuData = this.menuData.concat()
      const flattenItems = (items, key) =>
        items.reduce((flattenedItems, item) => {
          flattenedItems.push(item)
          if (Array.isArray(item[key])) {
            return flattenedItems.concat(flattenItems(item[key], key))
          }
          return flattenedItems
        }, [])
      const selectedItem = _.find(flattenItems(menuData, 'children'), [
        'url',
        pathname,
      ])
      this.selectedKeys = selectedItem ? [selectedItem.key] : []
    },
  },
}
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
